import React from 'react'
import PropTypes from 'prop-types'
import { StyledModal } from './component.styles'
import AddProgramRole from './AddProgramRole'
import ModalHeader from 'components/ModalHeader'
import ModalFooter from 'components/ModalFooter'

const ProgramRoleModal = ({
  entry,
  errors,
  handleChange,
  handleClose,
  handleNextButtonClick,
  hasApiError,
  isSubmitting,
  showApplyToAll,
  touched,
  values,
}) => {
  const { cancelLabel, helpCopy, nextLabel } = entry || {}

  return (
    <StyledModal
      dataTestId="program-role-modal"
      isModalOpen={true}
      modalClose={() => handleClose}
    >
      <ModalHeader handleClose={handleClose} showBackButton={false} />
      <AddProgramRole
        entry={entry}
        errors={errors}
        handleChange={handleChange}
        showApplyToAll={showApplyToAll}
        touched={touched}
        values={values}
      />
      <ModalFooter
        cancelButtonText={cancelLabel}
        handleCancelButtonClick={handleClose}
        handleNextButtonClick={() => handleNextButtonClick(true)}
        hasApiError={hasApiError}
        helpCopy={helpCopy}
        isSubmitting={isSubmitting}
        isValid={true}
        nextButtonText={nextLabel}
        showCancelButton={true}
      />
    </StyledModal>
  )
}

ProgramRoleModal.propTypes = {
  entry: PropTypes.object,
  errors: PropTypes.object,
  flowLabel: PropTypes.string,
  goBack: PropTypes.func,
  handleCancelButtonClick: PropTypes.func,
  handleChange: PropTypes.func,
  handleClose: PropTypes.func,
  handleNextButtonClick: PropTypes.func,
  hasApiError: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  isValid: PropTypes.bool,
  showApplyToAll: PropTypes.bool,
  touched: PropTypes.object,
  values: PropTypes.object,
}

export default ProgramRoleModal
